import React from "react";
import { useCountdown } from "../hooks/useCountdown";
export function PromoBar() {
  const time = useCountdown();
  return <div className="sticky top-0 z-50 border-b border-line bg-ink/95 backdrop-blur" data-id="element-98" data-mp="8aqcy0qtiux2">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-5 py-2.5 text-sm" data-id="element-99" data-mp="3hnjdsm1jlgv">
        <p className="text-cream" data-id="element-100" data-mp="3unylls2ses9s">
          <span className="mr-1.5 font-bold tracking-wider text-gold" data-id="element-101" data-mp="3umxbpqxicbtn">PROMO</span>
          <span className="hidden sm:inline" data-id="element-102" data-mp="3qozk6hg9ldn3">Pack de 6 volumes + 6 bonus offerts à -60 % — seulement 27 $. L'offre se termine ce soir.</span>
          <span className="sm:hidden" data-id="element-103" data-mp="3goz02takmthu">6 volumes + 6 bonus : 27 $</span>
        </p>
        <p className="flex shrink-0 items-center gap-2" data-id="element-104" data-mp="3gr1zu51j00zr">
          <span className="text-xs font-semibold tracking-widest text-mute" data-id="element-105" data-mp="3brfm7uhsciqf">FIN DANS</span>
          <span className="font-semibold tabular-nums text-gold" data-id="element-106" data-mp="1ewt040j0bkjh">{time}</span>
        </p>
      </div>
    </div>;
}